import React, { useState, useRef, useEffect } from "react";

const chats = [
  "7 and 8 figure earners",
  "HTML chat input analysis",
  "Hiring assistants in tech",
  "Cultural preferences and power",
  "Dating aspirations and reality",
  "Good deeds and reward",
  "Comment interpretation and response",
  "No-show warning letter",
];

export default function SidebarSearch() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      {/* Search Input */}
      <div
        className="relative flex items-center bg-gray-100 rounded-lg px-3 py-2 hover:bg-gray-200 cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="absolute left-3 text-gray-500"
          viewBox="0 0 16 16"
        >
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
        </svg>
        <input
          type="text"
          placeholder="Search chats..."
          className="pl-8 pr-2 w-full bg-transparent outline-none text-sm text-gray-700"
          readOnly
        />
      </div>

      {/* Glassmorphic Overlay */}
      {open && (
        <div
          className="fixed inset-0 z-50 flex justify-center items-start pt-24 px-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white/20 backdrop-blur-md rounded-xl shadow-lg w-full max-w-md p-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* New Chat Button */}
            <button className="w-full text-left px-4 py-2 mb-2 bg-white/30 rounded-md hover:bg-white/50 font-semibold">
              + New Chat
            </button>

            {/* Recent Chats List */}
            <div className="max-h-80 overflow-y-auto">
              {chats.map((chat, idx) => (
                <div
                  key={idx}
                  className="px-4 py-2 rounded-md hover:bg-white/30 cursor-pointer text-gray-800"
                >
                  {chat}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
